/**
 * AdminV3 — scaffold shell
 * Flag: adminV3
 * API: api/v3/admin (stub returning { message: 'AdminV3 stub' })
 * TODO: Replace stub with real admin RTK Query endpoints
 *       Rewrite: class component → hooks, apiFetch → RTK Query
 */
import React from 'react';
import { useGetAdminV3Query } from '../../api/adminV3Api';

export default function AdminV3() {
    const { data, isLoading, isError } = useGetAdminV3Query();

    if (isLoading) return <p>Loading…</p>;
    if (isError)   return <p>Error loading Admin.</p>;

    return (
        <main aria-label="Admin v3 (scaffold)">
            <p>AdminV3 scaffold — {JSON.stringify(data)}</p>
        </main>
    );
}
